"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const HelperUtils_1 = require("utils/HelperUtils");
const Shimmer_1 = __importDefault(require("components/design-system/shimmer/Shimmer"));
const defaultProps = {
    children: 'Card children',
    titleCard: null,
    customClass: '',
    rightComponent: '',
    isLoading: false,
    useHorizontalPadding: true,
    useVerticalPadding: true,
    borderColor: null,
    dataCy: '',
    bgColor: 'bg-n-000',
    onClick: () => null
};
const Card = ({ children, customClass, titleCard, rightComponent, isLoading, useHorizontalPadding, useVerticalPadding, borderColor, dataCy, key, onClick, bgColor }) => {
    const cardCN = (0, classnames_template_literals_1.default)(`
    border border-solid rounded
    ${bgColor}
    ${customClass}
    ${useVerticalPadding && 'py-[16px]'}
    ${useHorizontalPadding && 'px-[24px]'}
    ${borderColor || 'border-n-400'}
  `);
    return (react_1.default.createElement("div", { className: cardCN, "data-cy": dataCy, key: key, onClick: onClick },
        titleCard && (react_1.default.createElement("div", { className: "flex justify-between items-center h-[32px] mb-[16px]" }, isLoading ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Shimmer_1.default, { width: "20%", height: "24px", circle: true }),
            react_1.default.createElement(Shimmer_1.default, { width: "50%", height: "32px", circle: true }))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", { className: `typography-h500 ${useHorizontalPadding ? '' : 'pl-[24px]'}` }, (0, HelperUtils_1.getObjectiveLocale)(titleCard)),
            rightComponent)))),
        children));
};
Card.defaultProps = defaultProps;
exports.default = Card;
